/**
 * Created by tomers on 7/20/2014.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/audit-trail/auditTrailGridRowView.tmpl");
    var Button = require("ui/button/Button");
    var DateUtility = require("utils/DateUtility");

    var AuditTrailGridRowView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AuditTrailGridRowView = Marionette.ItemView.extend({
            template: template,
            tagName: "tr",
            className: "audit-trail-row",
            ui: {
                changeDate: ".changeDate",
                newValue: '.newValue',
                oldValue: '.oldValue',
                reviewChanges: '.reviewChanges'
            },
            uiComponents: {
                reviewChanges: {
                    type: Button,
                    options: {
                        el: "view.ui.reviewChanges",
                        permutation: Button.PERMUTATION.BLUELINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        click: "_onReviewChangesButtonClicked"
                    }
                }
            },
            initialize:  function (options) {
                this.channel = options.channel;
            },

            onRender: function() {
                this._updateActionType();
                this._updateDate();

                var showReviewChanges = this.model.shouldDisplayReviewChanges();
                this.ui.newValue.toggleClass('hide', showReviewChanges);
                this.ui.oldValue.toggleClass('hide', showReviewChanges);
                this.ui.reviewChanges.toggleClass('hide', !showReviewChanges);
            },

            _updateActionType: function() {

            },

            _updateDate: function() {
                var fullDateStr = this.model.getChangeDate();
                var fullDateParts = fullDateStr.split(" ");
                var date = fullDateParts[0];
                var time = fullDateParts[1];

                var dateStr = DateUtility.getDateToShow(date);

                var timeParts = time.split(":");
                var hour = timeParts[0];
                var mins = timeParts[1];

                var formattedDate = dateStr + " " + hour + ":" + mins;
                this.ui.changeDate.text(formattedDate);
            },

            _onReviewChangesButtonClicked: function () {
                this.channel.trigger('auditTrail:reviewChangesDialog:show', this.model);
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return AuditTrailGridRowView;
});
